import { IframePage } from '@app/pages/IframePage';

import { SALARY_SETTINGS_LABEL } from '../constants';
import { useSalarySettingsTab } from '../hooks/useSalarySettingsTab';

import type { FC } from 'react';

import './SalarySettingsTab.scss';

export interface SalarySettingsTabProps {
  userId: number;
}

export const SalarySettingsTab: FC<SalarySettingsTabProps> = ({ userId }) => {
  const { host } = useSalarySettingsTab({ userId });

  return (
    <div className="SalarySettingsTab">
      {/* key: адрес фрейма IframePage собирает один раз — новый сотрудник
          открывает новый фрейм. Филиал IframePage берёт активный сам. */}
      <IframePage
        key={host}
        host={host}
        title={SALARY_SETTINGS_LABEL}
        isEmbedded
      />
    </div>
  );
};
